import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const resource = "/admin/manufacture";

export default {

  // PRODUCTION LINE
  getProductionLineList(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/production_lines?paginate=${pagination}&page=${pageNumber}`)
  },
  getProductionLine(id) {
    return Repository.get(`${resource}/production_lines/${id}`)
  },
  updateProductionLine(id, payload) {
    return Repository.put(`${resource}/production_lines/${id}`, payload)
  },
  statusChangeProductionLine(id, status) {
    return Repository.put(`${resource}/production_line/${id}/${status}`)
  },
  createProductionLine(payload) {
    return Repository.post(`${resource}/production_lines`, payload)
  },
  getProductionLineStatus(payload) {
    return Repository.get(`${resource}/production_line_status`, payload)
  },
  getLiveProductionLineList(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/live_production_lines?paginate=${pagination}&page=${pageNumber}`)
  },

  //WORK ORDERS API
  getAllWorkOrders(pageNumber = 1, filterQuery, pagination = defaultPagination, sort = 'work_order_code') {
    return Repository.get(`${resource}/work_orders?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getWoForTastePanel(filterQuery) {
    return Repository.get(`${resource}/work-order-taste-panel-list?${filterQuery}`)
  },
  getAllWorkOrdersDropdown(date_from, date_to) {
    return Repository.get(`${resource}/work-order-list?date_from=${date_from}&date_to=${date_to}`)
  },
  getAllConfirmedWoWithoutPagination(search='',date_from, date_to) {
    return Repository.get(`${resource}/work-order-confirmed?filter[search]=${search}&date_from=${date_from}&date_to=${date_to}`)
  },
  getFormulationsOrderList(filterQuery, sort = 'required-by', pageNumber = 1, pagination = 10, is_paginate = 1) {
    return Repository.get(`${resource}/formulation?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}&is_paginate=${is_paginate}`)
  },
  getFormulationsOrderListForStock(filterQuery, pageNumber = 1, pagination = 10, is_paginate = 1) {
    return Repository.get(`${resource}/formulation_stock?paginate=${pagination}&page=${pageNumber}&${filterQuery}&is_paginate=${is_paginate}&${filterQuery}`)
  },
  getFormulationsOrderItems(id) {
    return Repository.get(`${resource}/formulation/${id}`)
  },
  createWorkOrder(payload) {
    return Repository.post(`${resource}/work_orders`, payload)
  },
  getWorkOrder(id){
    return Repository.get(`${resource}/work_orders/${id}`)
  },
  updateWorkOrder(id, payload) {
    return Repository.put(`${resource}/work_orders/${id}`, payload)
  },
  updateWorkOrderDateTime(id, payload) {
    return Repository.put(`${resource}/work_order/${id}/time_update`, payload)
  },
  workOrderStatusChange(id, status, payload) {
    return Repository.put(`${resource}/work_order/${id}/${status}`, payload)
  },
  updateWorkOrderReservedBatches(id, payload) {
    return Repository.put(`${resource}/work_order/${id}/reserved-batches`, payload)
  },
  deleteWorkOrderReservedBatches(id, payload) {
    return Repository.delete(`${resource}/work_order/${id}/reserved-batches`, { data: payload })
  },
  workOrderStartCleanDown(id, payload) {
    return Repository.put(`${resource}/work_order/${id}/start_clean_time`, payload)
  },
  workOrderEndCleanDown(id, payload) {
    return Repository.put(`${resource}/work_order/${id}/end_clean_time`, payload)
  },
  workOrderLog(id) {
    return Repository.get(`${resource}/work_order/${id}/logs`)
  },
  getFormulationStockForWorkOrder(id) {
    return Repository.get(`${resource}/${id}/formulation_stock_details`)
  },
  updateWorkOrderDetails(id, payload) {
    return Repository.put(`${resource}/work_order/${id}/update-details`, payload)
  },

  // formulation stock API
  getFormulationStock(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/formulation_stock_inventories?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  assignFormulationStock(payload) {
    return Repository.post(`${resource}/formulation_stock_inventories`, payload)
  },
  getProductionLineTakenTimeSlots(id, date) {
    return Repository.get(`${resource}/production_line_availability/${id}?date=${date}`)
  },
  updateFormulationStockInventory(id, payload) {
    return Repository.put(`${resource}/formulation_stock_inventories/${id}`, payload)
  },
  unAllocateFormulationStockInventory(id) {
    return Repository.put(`${resource}/formulation-stock-inventory/${id}/unallocate`)
  },

  // raw material stock API
  getRawMaterialStock(pageNumber = 1, filterQuery, pagination = defaultPagination, sort = 'expiration-date') {
    return Repository.get(`${resource}/raw_material_stock_inventories?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getRawMaterialStockForTastePanel(filterQuery) {
    return Repository.get(`${resource}/raw-material-stock-inventory-taste-panel-list?${filterQuery}`)
  },
  updateRawMaterialStock(id, data) {
    return Repository.put(`${resource}/raw_material_stock_inventories/${id}`, data)
  },
  createRawMaterialStock(data) {
    return Repository.post(`${resource}/raw_material_stock_inventories`, data)
  },
  getRawMaterialStockDetails(id) {
    return Repository.get(`${resource}/raw_material_stock_inventories/${id}`)
  },
  toggleRawMaterialStockOpened(id, payload) {
    return Repository.put(`${resource}/raw-material-inventory/${id}/opened`, payload)
  },
  getRawMaterialOnHoldStock(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/inventory/stock/raw-material-on-hold-inventories?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },

  //sundry inventory
  getSundryInventory(pageNumber= 1, pagination = defaultPagination, filterQuery, sort = '') {
    return Repository.get(`${resource}/sundry_item_stock_inventories?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  createWorkOrderWithSundryItem(payload) {
    return Repository.post(`${resource}/work_order_sundry_items`, payload)
  },
  updateWorkOrderWithSundryItem(wo_id, payload) {
    return Repository.put(`${resource}/work_order_sundry_items/${wo_id}`, payload)
  },
  createSundryItemInventory(payload) {
    return Repository.post(`${resource}/sundry_item_stock_inventories`, payload)
  },
  getSundryItemInventory(id) {
    return Repository.get(`${resource}/sundry_item_stock_inventories/${id}`)
  },
  updateSundryItemInventory(id, payload) {
    return Repository.put(`${resource}/sundry_item_stock_inventories/${id}`, payload)
  },

  updateWorkOrderWithCcpItem(wo_id, payload) {
    return Repository.post(`${resource}/work_order/${wo_id}/ccp-items`, payload)
  },
  fetchWorkOrderSelectedCcpItems(wo_id) {
    return Repository.get(`${resource}/work_order/${wo_id}/ccp-items`)
  },
  fetchApplicableCcpItems(wo_id) {
    return Repository.get(`${resource}/work_order/${wo_id}/applicable-ccp-items`)
  },

  // QC test
  getWorkOrderQcTest(id) {
    return Repository.get(`${resource}/work_order/${id}/q-c-tests`)
  },
  createWorkOrderQcTest(id, payload) {
    return Repository.post(`${resource}/work_order/${id}/q-c-tests`, payload)
  },
  updateWorkOrderQcTest(wo_id, qc_test_id, payload) {
    return Repository.put(`${resource}/work_order/${wo_id}/q-c-tests/${qc_test_id}`, payload)
  },

  // RETURN TO INVENTORY API
  checkAutoCancellation(payload) {
    return Repository.post(`${resource}/work_order/check_auto_cancellation`, payload)
  },

  // WORK ORDER PDF WITH SEDR3T CODE
  getWorkOrderPdfData(secret) {
    return Repository.get(`${resource}/work_order/${secret}/pdf`)
  },
  getWorkOrderListPdfData() {
    return Repository.get(`${resource}/work-order/list-pdf`)
  },
  getWorkOrderQrData(id){
    return Repository.get(`${resource}/work_order/${id}/app-qr-code`)
  },
  getWorkOrderStock(id) {
    return Repository.get(`${resource}/work_order/${id}/stock-availability-check`)
  },
  //3rd party rm in wo
  update3rdPartyRmBatchDetails(wo_id, payload) {
    return Repository.put(`${resource}/work_order/${wo_id}/update-spray-dry-batches`, payload)
  }
};
